/**
 * UI配置类型枚举
 * 使用 TypeScript enum 定义配置类型
 */

/**
 * 配置类型枚举
 */
export enum UiConfigType {
  /** 列表配置 */
  LIST = 1,
  /** 表单配置 */
  FORM = 2,
  /** 置顶 */
  PIN_TOP = 3
}

/**
 * 配置类型名称映射
 */
export const CONFIG_TYPE_NAMES: Record<UiConfigType, string> = {
  [UiConfigType.LIST]: '列表配置',
  [UiConfigType.FORM]: '表单配置',
  [UiConfigType.PIN_TOP]: '置顶'
}

/**
 * 获取配置类型名称
 * @param configType 配置类型
 * @returns 配置类型名称
 */
export const getConfigTypeName = (configType: UiConfigType): string => {
  return CONFIG_TYPE_NAMES[configType] || '未知类型'
}

/**
 * 获取配置类型选项
 * @returns 配置类型选项数组
 */
export const getConfigTypeOptions = () => {
  return Object.entries(CONFIG_TYPE_NAMES).map(([value, label]) => ({
    label,
    value: Number(value)
  }))
}

/**
 * 验证配置类型是否有效
 * @param configType 配置类型
 * @returns 是否有效
 */
export const isValidConfigType = (configType: number): configType is UiConfigType => {
  return Object.values(UiConfigType).includes(configType as UiConfigType)
}